let instance;
/**
 * Creates instance of debugConsole object.
 * @return {Object} object with function properties listed in commands const below
 */
function setupDebugConsole() {
  const globalScope = typeof window !== 'undefined' ? window : global;
  const commands = [
    'log',
    'warn',
    'error',
    'info',
    'time',
    'timeEnd',
    'group',
    'groupEnd',
    'groupCollapsed',
    'dir',
    'debug',
    'trace',
  ];

  let debugEnabled = false;
  if (
    typeof globalScope === 'object'
    && 'localStorage' in globalScope
    && typeof globalScope.localStorage.getItem === 'function'
    && globalScope.localStorage.getItem('sg_debug') === 'enabled'
  ) {
    debugEnabled = true;
  }

  instance = {};

  if (typeof globalScope.console !== 'object') {
    globalScope.console = {};
  }

  /**
   * Adds console function to the instance.
   * @param {string} commandName name of the commaand
   * @return {Function}
   */
  const addFunctionForConsoleCommand = (commandName) => {
    return function (args) {
      if (!debugEnabled) {
        return;
      }

      let consoleArguments = arguments;

      if (Array.isArray(args)) {
        consoleArguments = args;
      }

      globalScope.console[commandName].apply(console, consoleArguments);
    };
  };

  commands.forEach((commandName) => {
    if (typeof globalScope.console[commandName] !== 'function') {
      globalScope.console[commandName] = function () {};
    }

    instance[commandName] = addFunctionForConsoleCommand(commandName);
  });
}

/**
 * Returns singleton instance of debugConsole function
 * @param {bool} forceNew - forces new instance
 * @return {*}
 */
function getInstance(forceNew) {
  if (!instance || forceNew) {
    setupDebugConsole();
  }

  return instance;
}

export default getInstance;



// WEBPACK FOOTER //
// ./Library/1.0/common/debug/debug-console.js